module.exports = __webpack_public_path__ + "static/media/help_Inicio.26c34114.png";